import cn from 'classnames'
import React, { FC } from 'react'
import { ContainerProps } from './types'
import s from './container.module.css'

const Container: FC<ContainerProps> = ({ children, className, clean, size = undefined }) => {
  const rootClassName = cn(className, !clean && s.root, size !== undefined && s[`${size}`])
  const Component: React.ComponentType<React.HTMLAttributes<HTMLDivElement>> = 'div' as any
  return <Component className={rootClassName}>{children}</Component>
}

export default Container
